import { cn } from "admin-ui/utils/cn"
import { IconProps } from "."

export default function LineGlobe({
  className,
  transform,
  ...reset
}: Readonly<IconProps>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-6 w-6", className)}
      transform={transform}
      {...reset}
    >
      <g clipPath="url(#clip0_5570_6158)">
        <path
          d="M5.12978 8.78822C5.09067 8.73044 4.36978 7.61222 4.91644 6.49933C4.976 6.37755 5.34667 5.65578 6.11111 5.44333C7.24267 5.12955 8.06933 6.26022 8.60444 5.91889C9.20267 5.53755 8.36444 4.00244 9.05511 3.13755C9.58133 2.47889 10.7404 2.52778 11.6178 2.66555"
          stroke="#52525B"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.12978 8.78835C6.54222 8.39812 7.45067 8.58923 8.056 8.9439C8.89067 9.43279 8.95022 10.1155 9.66667 10.2497C10.7004 10.4435 11.3058 9.15901 12.2222 9.33323C12.648 9.41412 13.1662 9.81501 13.616 11.1617"
          stroke="#52525B"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.64533 14.4266C7.77689 13.9119 7.85333 13.2328 7.50044 12.7039C7.12444 12.1395 6.59289 12.2444 6.23644 11.6532C5.86489 11.0364 6.24889 10.5999 5.97244 9.83369C5.71289 9.11458 5.11822 8.79014 4.672 8.46391C3.92889 7.9208 3.00622 6.94302 2.28267 5.03369"
          stroke="#52525B"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 14.4446C11.5592 14.4446 14.4444 11.5593 14.4444 8.00011C14.4444 4.44094 11.5592 1.55566 8 1.55566C4.44083 1.55566 1.55556 4.44094 1.55556 8.00011C1.55556 11.5593 4.44083 14.4446 8 14.4446Z"
          stroke="#52525B"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5570_6158">
          <rect
            width="15"
            height="15"
            fill="white"
            transform="translate(0.5 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
